/**
 * Host Config
 * @type {string}
 */
import {isWeiXin} from "@utils/tools";
import { appkey } from "./getSign";

export const staticHost = '';
const _base = '//admin-gstzy.oss-cn-shenzhen.aliyuncs.com';
const _picHost = '//www.gstzy.cn';

let __host = {
  php: `${staticHost}/api/`,
  dr_img: `${_base}/data/upload/`, //图片服务器
  picHost: `${_picHost}`, // 图片服务器地址(运营后台)
  defAvatar: `${_base}/data/upload/doctor/201603/25/56f4e1fc9e01c.png`,
  defaultDocImg: '/assets/img/i-Doctor-head-default.png',
  go: `${staticHost}/api/stg-go-api.gstyun.cn/`,
  map: `${staticHost}/api/apis.map.qq.com/`, //腾讯地图接口
};
console.log('process.env.NODE_ENV', process.env.REACT_APP_ENV);

switch (process.env.REACT_APP_ENV) {
  // case 'development':
  case 'dev': //外网测试环境
    __host = Object.assign({}, __host, {
      dr_img: `//admin.gstyun.local/data/upload/`, //图片服务器
      cplus: `//beta-cgi.gstyun.cn/`,
      banner: `${staticHost}/api/admin.gstyun.local/`,
      healthAdHost: `${staticHost}/api/api.gstyun.local/`,
      dplat: `//data-api.gstzy.cn:63306/`,
      distribution: `${staticHost}/api/ec.gstyun.local/`,
      news: `${staticHost}/api/news.gstyun.local/`,
      oldHost: `${staticHost}/api/chat.gstyun.local/`, // 轻问诊
      goapi: `${staticHost}/api/go-api-local.gstyun.cn/`,
      wxapi: `https://wx.gstyun.cn/`,
      staticSource: `//static.gstyun.local/`,
      cas: `${staticHost}/api/cas.360gst.com/`, //cas系统
      omoVideo: `${staticHost}/api/omo.test.gstyun.cn/phpapi/`,
      mcrm: 'http://mcrm.test.bailuzy.com',
      defaultCashier: {
        //默认收银员
        id: '1',
        number: '1066',
        userName: 'mPay',
        realName: '移动收银员',
        email: 'mobilepay@360gst.com',
      },
      medicalPayClinics: ['311'], //支持移动医保支付的分院。
      vipArg: 'http://mobile.patient.test.bailuzy.com/mobile/user/memberAgreement',
      appkey: 'wnsmh01KAEhjqOr2I7iI6x91v8jeUZCovfrqPLlffVQ=',
    });
    break;
  case 'development':
  case 'test':
    __host = Object.assign({}, __host, {
      dr_img: `//admin.gstyun.local/data/upload/`, //图片服务器
      cplus: `${staticHost}/apic/beta-cgi.gstyun.cn/`,
      banner: `${staticHost}/api/admin.gstyun.local/`,
      healthAdHost: `${staticHost}/api/api.gstyun.local/`,
      dplat: `//data-api.gstzy.cn:63306/`,
      distribution: `${staticHost}/api/ec.gstyun.local/`,
      news: `${staticHost}/api/news.gstyun.local/`,
      oldHost: `${staticHost}/api/chat.gstyun.local/`, // 轻问诊
      wxapi: `${staticHost}/api/wx.gstyun.cn/`,
      goapi: `${staticHost}/apic/go-api-local.gstyun.cn/`,
      staticSource: `//static.gstyun.local/`,
      cas: `${staticHost}/api/cas.360gst.com/`, //cas系统
      omoVideo: `${staticHost}/api/omo.test.gstyun.cn/phpapi/`,
      mcrm: 'http://mcrm.test.bailuzy.com',
      defaultCashier: {
        //默认收银员
        id: '1',
        number: '1066',
        userName: 'mPay',
        realName: '移动收银员',
        email: 'mobilepay@360gst.com',
      },
      medicalPayClinics: ['311'], //支持移动医保支付的分院。
      vipArg: 'http://mobile.patient.test.bailuzy.com/mobile/user/memberAgreement',
      appkey: 'wnsmh01KAEhjqOr2I7iI6x91v8jeUZCovfrqPLlffVQ=',
    });
    break;
  // case 'development':
  case 'stg':
    __host = Object.assign({}, __host, {
      cplus: `${staticHost}/apic/stg-cgi.gstyun.cn/`,
      banner: `${staticHost}/api/admin.360gst.com/`,
      healthAdHost: `${staticHost}/api/api.gstyun.cn/`,
      dplat: `${staticHost}/apic/data-api.gstzy.cn/`,
      // dplat         : `${staticHost}/apic/120.76.26.54:63306/`,
      distribution: `${staticHost}/api/ec.gstzy.cn/`, //php没stg环境
      news: `${staticHost}/api/news.gstyun.cn/`,
      oldHost: `${staticHost}/api/chat.gstyun.cn/`, // 轻问诊 线上环境
      goapi: `${staticHost}/api/go-api.gstyun.cn/`,
      // goapi: isWeiXin() ? `//h5.gstyun.cn/goapi/`: `//h5.gstzy.cn/goapi/`,
      wxapi: `https://wx.gstyun.cn/`,
      staticSource: `//stg.gstyun.cn/`,
      cas: `${staticHost}/api/cas.360gst.com/`, //cas系统
      omoVideo: `${staticHost}/api/omo.gstyun.cn/phpapi/`,
      mcrm: 'https://mcrm.gstyun.cn',
      defaultCashier: {
        //默认收银员
        id: '966',
        number: '0221',
        userName: 'limeilan',
        realName: '移动收银员',
        email: 'meilan.li@360gst.com',
      },
      medicalPayClinics: ['265', '267', '264', '266', '251', '311', '406'], //支持移动医保支付的分院。
      vipArg: 'https://mobile.patient.51wenzy.com/mobile/user/memberAgreement',
      appkey: 'xRj3kx7iAznAzqBUkMnj0DUC8/u4iz2dpx1CifuRqyY=',
    });
    break;
  // case 'development':
  case 'production':
  default:
    // 生产环境
    __host = Object.assign({}, __host, {
      // cplus: `${staticHost}/apic/cgi.gstyun.cn/`,
      cplus: isWeiXin() ? `//h5.gstyun.cn/`: `//h5.gstzy.cn/`, //`${staticHost}/apic/cgi.gstyun.cn/`,
      banner: `${staticHost}/api/admin.360gst.com/`,
      dplat: `${staticHost}/apic/data-api.gstzy.cn/`,
      distribution: `${staticHost}/api/ec.gstzy.cn/`,
      healthAdHost: `${staticHost}/api/api.gstyun.cn/`,
      news: `${staticHost}/api/news.gstyun.cn/`,
      oldHost: `${staticHost}/api/chat.gstyun.cn/`, // 轻问诊
      goapi: `${staticHost}/api/setout-go-api.gstyun.cn/`,
      // goapi: isWeiXin() ? `//h5.gstyun.cn/goapi/`: `//h5.gstzy.cn/goapi/`,
      wxapi: `https://wx.gstyun.cn/`,
      staticSource: `//stg.gstyun.cn/`,
      cas: `${staticHost}/api/cas.360gst.com/`, //cas系统
      omoVideo: `${staticHost}/api/omo.gstyun.cn/phpapi/`,
      mcrm: 'https://mcrm.gstyun.cn',
      defaultCashier: {
        //默认收银员
        id: '966',
        number: '0221',
        userName: 'limeilan',
        realName: '移动收银员',
        email: 'meilan.li@360gst.com',
      },
      medicalPayClinics: ['406'], //, '265','267', '264', '266', '251', '311'],//支持移动医保支付的分院。
      vipArg: 'https://mobile.patient.51wenzy.com/mobile/user/memberAgreement',
      appkey: 'xRj3kx7iAznAzqBUkMnj0DUC8/u4iz2dpx1CifuRqyY=',
    });
}

export const host = __host;

// 固生堂岭南中分院东山门诊部 265
// 固生堂岭南中分院淘金门诊部 267
// 固生堂岭南中分院          264
// 固生堂岭南中分院水荫门诊部 266
// 广州天河固生堂医疗门诊部  251
// 广州海珠固生堂中医门诊部  311
// 固生堂中医肿瘤专科门诊部  406
